module.exports = __webpack_public_path__ + "static/img/pete_pictgrid30_1020x855.38de869.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pete_pictgrid30_1020x855.jpg
// module id = 8Qni
// module chunks = 0